import {
  Alert,
  Box,
  Button,
  TextField,
  ThemeProvider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ExpoTheme } from "../../../theme/theme";
import RegHeader from "../../../components/headers/regHeader";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import { API_ENDPOINT, EXHIBITOR_API } from "../../../constants/constants";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import MuPb from "../../../widgets/MuPb";
import BackBtn from "../../dashboard/admin/widgets/BackBtn";
import Footer from "../../footer/footer";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AttachFile from "@mui/icons-material/AttachFile";
import { MuiTelInput } from "mui-tel-input";
import { EbadgeService } from "../../dashboard/visitor/EbadgeService";
const ServiceBadgePreview = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [exhibitor, setExhibitor] = useState();
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    document.title = "SERVICE BADGE";
  }, []);

  useEffect(() => {
    loadUser();
  }, []);
  async function loadUser() {
    setLoading(true);
    try {
      const response = await axios.get(
        EXHIBITOR_API +
          `get-service-badge-person-mobile?id=${encodeURIComponent(id)}`
      );
      if (response.status === 200) {
        setExhibitor(response.data);
      } else if (response.status === 204) {
        // Handle successful response with no content
        toast.info("No Exhibitor Found with Mobile Number.");
      }
    } catch (error) {
      // Check if the error has a response object
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMsg(error.response.data.message);
        // If the response has a data object with a message, display it
        toast.error(error.response.data.message);
      } else {
        // Otherwise, fall back to a generic error message
        toast.error("An error occurred while fetching. Please try again.");
        setErrorMsg("An error occurred while fetching. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  }
  if (loading) {
    return <MuPb />;
  }
  if (errorMsg) {
    return (
      <Alert severity="warning">
        <Typography variant="subtitle1">{errorMsg}</Typography>
      </Alert>
    );
  }

  return (
    <ThemeProvider theme={ExpoTheme}>
      <Box
        sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <RegHeader />
        {/* <Box mt={2} ml={2}>
            <BackBtn />
          </Box> */}
        <Box mt={2} width={"100%"} maxWidth={420} ml={"auto"} mr={"auto"}>
          <Box sx={{ p: 2, textAlign: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
              PLEASE SHOW THIS BADGE AT THE SECURITY TO ENTER.
            </Typography>

            <Box
              display={"flex"}
              justifyContent={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              {exhibitor && <EbadgeService user={exhibitor} isPreview={true} />}
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 4,
            flexGrow: 1, // This will make the box grow to fill available space
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <Footer />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default ServiceBadgePreview;
